import { useEffect, useState } from 'react';
import styles from '../../pages/ProductSelection.module.css';
import { ReactComponent as CloseIcon } from '../../images/icons/ProductSelectionPage/closeicon.svg';
import { ReactComponent as PlaceholderIcon } from '../../images/icons/ProductSelectionPage/placeholdericon.svg';

export const PhotoModalImage = ({ imageUrl, alt = 'Photo', imageClassName, isOpen }) => {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [imageUrl, isOpen]);

  const showImage = Boolean(imageUrl) && !imageFailed;

  if (showImage) {
    return (
      <img
        src={imageUrl}
        alt={alt}
        className={imageClassName || styles.enlargedImage}
        draggable={false}
        onError={() => setImageFailed(true)}
      />
    );
  }

  return (
    <div className={styles.placeholderContainer}>
      <PlaceholderIcon className={styles.placeholderIcon} />
    </div>
  );
};

const PhotoModal = ({
  isOpen,
  onClose,
  ariaLabel = 'Enlarged photo view',
  contentClassName = '',
  imageContainerClassName = '',
  transparentContent = false,
  fileName,
  children,
}) => {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  const modalContentClassName = [
    styles.modalContent,
    contentClassName,
    transparentContent ? styles.modalContentTransparent : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={styles.modalOverlay}
      onClick={handleBackdropClick}
      role="dialog"
      aria-modal="true"
      aria-label={ariaLabel}
    >
      <div className={modalContentClassName}>
        <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close modal"
          type="button"
        >
          <CloseIcon />
        </button>

        <div className={`${styles.imageContainer} ${imageContainerClassName}`.trim()}>
          {children}
        </div>

        {fileName ? (
          <div className={styles.fileNameContainer}>
            <span className={styles.fileName}>{fileName}</span>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PhotoModal;
